import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

const RotatingCursor = ({ text = "VIEW PROJECT • VIEW PROJECT •" }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [rotation, setRotation] = useState(0);
    const [visible, setVisible] = useState(false);
    const [radius, setRadius] = useState(50);
    const textRef = useRef(null);


    useEffect(() => {
        const move = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
            setRotation((prev) => prev + 1);
        };

        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);

    //   if (!visible) return null;

    useEffect(() => {
        if (textRef.current) {
            const textLength = textRef.current.getComputedTextLength();
            const calculatedRadius = textLength / (2 * Math.PI);
            setRadius(calculatedRadius);
        }
    }, [text]);

    const size = radius * 2 + 20;

    return (
        <Box
            sx={{
                position: "fixed", // 🔥 IMPORTANT (not absolute)
                top: 0,
                left: 0,
                transform: `translate(${position.x}px, ${position.y}px) translate(-50%, -50%)`,
                pointerEvents: "none",
                zIndex: 9999,
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    width: size,
                    height: size,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transform: `rotate(${rotation}deg)`,
                    transition: "transform 0.1s linear",
                }}
            >
                <svg width={size} height={size}>
                    <defs>
                        <path
                            id="circlePath"
                            d={`
                M ${size / 2}, ${size / 2}
                m -${radius}, 0
                a ${radius},${radius} 0 1,1 ${radius * 2},0
                a ${radius},${radius} 0 1,1 -${radius * 2},0
              `}
                        />
                    </defs>
                    <text ref={textRef}
                        fill="black" fontSize="12">
                        <textPath href="#circlePath">
                            {text}
                        </textPath>
                    </text>
                </svg>
            </Box>
        </Box>
    );
};

export default RotatingCursor;
